export default "__VITE_ASSET__9MyHzlVk__"